const CleverPushAppBuilder = window.CleverPushAppBuilder;

export const setStorageItem = (key, value) => {
  try {
    const valueToStore = typeof value === 'object' ? JSON.stringify(value) : value;

    // Regular localStorage setItem
    localStorage.setItem(key, valueToStore);

    // If App Builder exists, also use its storage
    if (CleverPushAppBuilder?.storage?.setItem) {
      CleverPushAppBuilder.storage.setItem(key, valueToStore);
    }
  } catch (err) {
    // Silent fail when localStorage is unavailable
  }
};

export const getStorageItem = (key) => {
  try {
    const value = localStorage.getItem(key);

    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    return value;
  } catch (err) {
    // Silent fail when localStorage is unavailable
    return null;
  }
};

export const removeStorageItem = (key) => {
  try {
    // Remove from regular localStorage
    localStorage.removeItem(key);

    // If App Builder exists, also remove from its storage
    if (CleverPushAppBuilder?.storage?.removeItem) {
      CleverPushAppBuilder.storage.removeItem(key);
    }
  } catch (err) {
    // Silent fail when localStorage is unavailable
  }
};
